<script lang="ts">
  import type { ComponentType } from 'svelte'

  import { twMerge } from 'tailwind-merge'
  export let icon : ComponentType
  export let title: string
  export let description: string
  let styles :string = ''
  export { styles as class }
</script>
<div class={twMerge('mx-auto bg-white border-4 z-1000 p-4  max-w-[80%]', styles)} role="alert" data-test-id="not-found-booking">
  <div class="flex flex-col lg:flex-row w-full justify-center items-center">
      <svelte:component this={icon} class="h-44 w-44 text-cs-orange" />
    <div class="ml-3 text-center flex flex-col justify-center w-full">
      <p class="font-bold text-2xl mb-2">
        {title}
      </p>
      <p class="text-md">
        {description}
      </p>
    </div>
  </div>
</div>
